import React from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'reactstrap';
import moment from 'moment';
import PickupSkipView from  '../Runs/PickupSkipView';
import {
    Aux,
    BASE_URL,
    IsCordovaApp,
    IsInRole,
    isNullEmptyOrWhitespace, IsNullOrUndefined, ROLE_Driver, URGENT_RUN_TAKE_PHOTOS_MESSAGE,
} from "../../constants";
import {push} from "../../utils/navigation";
import store from '../../store';
import { isKioskMode } from '../../utils/kiosk';
import PickupImageViewer from "./PickupImageViewer";
import {
    runLocationCheckIn,
    runLocationCompleteAssignTank,
    runLocationCompletePickup,
    saveRunReorder,
    updatePickupPhotos,
    loadRun
} from "../../actions/runActions";
import { setPickupContext, clearPickupContext } from "../../actions/truckDataActions";
import { assignReceipt, assignReceipts, loadRunReceipts, unassignReceipt } from "../../actions/receiptActions";
import SelectReceiptModal from "../Common/SelectReceiptModal";
import SelectCollectionReceiptsModal from "../Common/SelectCollectionReceiptsModal";
import PickupStatus from "./PickupStatus";
import CheckInView from "./CheckInView";
import CheckOutView from "./CheckOutView";
import TankInput from "./TankInput";
import TinInput from "./TinInput";
import scrollToComponent from "../../assets/libs/custom-react-scroll-to-component";
import TankRequestInput from "./TankRequestInput";
import TankAssignView from "./TankAssignView";
import QrAssetUpdateIcon from '../QR/QrAssestUpdate';
import { isUploadedFileValid, mustBeArray, requestHasError } from '../../utils/lib';
import {getCollectionAction, getRunFlag, getRunFlagBadgeClass, getRunFlagIcon, getRunTypeCardStyle, isPickupUrgentForRunType} from "../../utils/collectionTypes";
import ReactFileReader from 'react-file-reader';
import { toastr } from 'react-redux-toastr';
import _ from 'lodash';
import {connect} from 'react-redux';
import { getGlobalSettings } from '../../actions/globalSettingAction';
import { GlobalSettings } from '../../utils';

const CommonNotes = ['Please phone','Tank needs changing', 'Please organise a key/card'];
const CancelNotes = ['Truck full', 'No car parking', 'No access', 'Can\'t find equipment', 'Shop closed', 'Tank swap asap'];

const defaultWeight = {
    isWeighing: false,
    tankId: null,
};

// A collection tank's total is the SUM of every collection receipt assigned to it (a driver often
// vacuums one tank in several bursts, pausing between them) -- see plan §0 "sum/subtract
// implementation". Deriving it fresh from the authoritative runReceipts list on every update (not
// accumulating client-side) means selecting more receipts "adds" and unassigning "subtracts"
// automatically, and stays correct across refreshes/SignalR pushes without hand-rolled arithmetic.
// Returns null only when the receipt list isn't loaded for this run yet (skip — leave tank state
// as-is). Once loaded, returns the sum even when it's 0, so unassigning the last receipt off a
// tank correctly resets its litres rather than leaving a stale value behind.
const sumCollectionReceiptLitres = (runReceipts, runId, pickupId, tankId) => {
    if (!runReceipts || runReceipts.runId !== runId || !Array.isArray(runReceipts.items)) {
        return null;
    }
    return runReceipts.items
        .filter(r => r.type === 'Collection' && r.pickupId === pickupId && r.tankId === tankId)
        .reduce((sum, r) => sum + (Number(r.litres != null ? r.litres : r.deliveryTotal) || 0), 0);
};

class DriverPickupView extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isNoteView: false,
            isCancelView: false,
            cancelNoteItems: [],            
            isOpen: props.pickup.pickupStatusCode !== 'COM',            
            isEditMode: false,
            isCancelMode: false,
            pickup: props.pickup,
            weight: {...defaultWeight},
            urgentPhotoUploadRequired: true,
            receiptModalOpen: false,
            receiptModalTank: null,
            collectionReceiptModalOpen: false,
            collectionReceiptModalTank: null,
        };

        this.openReceiptModal = this.openReceiptModal.bind(this);
        this.closeReceiptModal = this.closeReceiptModal.bind(this);
        this.handleSelectReceipt = this.handleSelectReceipt.bind(this);
        this.openCollectionReceiptModal = this.openCollectionReceiptModal.bind(this);
        this.closeCollectionReceiptModal = this.closeCollectionReceiptModal.bind(this);
        this.handleSelectCollectionReceipts = this.handleSelectCollectionReceipts.bind(this);
        this.onBeginEdit = this.onBeginEdit.bind(this);
        this.onCancelEdit = this.onCancelEdit.bind(this);
        this.toggleIsOpen = this.toggleIsOpen.bind(this);
        this.handleCancelPickup = this.handleCancelPickup.bind(this);
        this.onCancelPickup = this.onCancelPickup.bind(this);
        this.onCompletePickup = this.onCompletePickup.bind(this);
        this.handleTankInput = this.handleTankInput.bind(this);
        this.handleTinInput = this.handleTinInput.bind(this);
        this.onCompleteCancel = this.onCompleteCancel.bind(this);
        this.onSkipComplete = this.onSkipComplete.bind(this);
        this.raiseOnEditChange = this.raiseOnEditChange.bind(this);
        this.onLocationCheckInOut = this.onLocationCheckInOut.bind(this);
        this.scrollRef = React.createRef();
        this.handleTankPickup = this.handleTankPickup.bind(this);
        this.handleAssignTank = this.handleAssignTank.bind(this);
        this.handleFinaliseAssignTank = this.handleFinaliseAssignTank.bind(this);
        this.handleBeginDelivery = this.handleBeginDelivery.bind(this);
        this.handleEndDelivery = this.handleEndDelivery.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let {pickup, truckData, run} = this.props;
        let {isEditMode} = this.state;

        if (JSON.stringify(prevProps.pickup) !== JSON.stringify(pickup)) {
            // Completed and cancelled pickups are both terminal - close edit mode.
            // Otherwise keep whatever edit state the driver is currently in (begin/cancel
            // drive it explicitly), so a run reload can't force a pending pickup back open.
            let isTerminal = pickup.pickupStatusCode === 'COM' || pickup.pickupStatusCode === 'CAN';
            this.setState({
                pickup,
                isOpen: !isTerminal,
                isEditMode: isTerminal ? false : isEditMode,
            });
        }

        if(prevState.isEditMode !== isEditMode){
            this.raiseOnEditChange();
        }

        // Auto-populate from receipt for delivery runs
        const isCollectionRun = run.isCollectionRun !== false;
        if (!isCollectionRun &&
            isEditMode &&
            truckData?.receipt &&
            truckData.receipt.pickupId === this.state.pickup.id &&
            truckData.receipt.tankId &&  // Must have tankId
            prevProps.truckData?.receipt?.receiptId !== truckData.receipt.receiptId) {

            const deliveryTotal = truckData.receipt.deliveryTotal;
            const receiptTankId = truckData.receipt.tankId;

            // Update ONLY the matching tank with the delivery total
            let pickupTanks = [...this.state.pickup.pickupTanks.map(x => {
                if (x.tankID === receiptTankId) {
                    console.log(`delivery total ${deliveryTotal}L for tank ${receiptTankId} applied from receipt`);
                    return {
                        ...x,
                        driverEstimatedLitresPickedUp: deliveryTotal,
                        isScalesConnected: false,
                        isManualEntry: false,
                    };
                }
                return x;
            })];

            this.setState({
                pickup: { ...this.state.pickup, pickupTanks },
                weight: {...this.state.weight,
                    isWeighing: false,
                    tankId: null,
                }
            });

            const matchingTank = this.state.pickup.pickupTanks.find(x => x.tankID === receiptTankId);
            toastr.success(`Receipt received: ${deliveryTotal}L delivered to Tank #${matchingTank?.tankID || receiptTankId}`);
        }

        // Collection runs: each tank's litres is the SUM of its assigned collection receipts,
        // recomputed from the authoritative runReceipts list whenever it changes (a manual load,
        // an assign/unassign completing, or a live SignalR-triggered refresh) rather than tracked
        // via client-side arithmetic — see sumCollectionReceiptLitres above.
        if (isCollectionRun && this.props.runReceipts !== prevProps.runReceipts) {
            this.recomputeCollectionTankSums();
        }
    }

    recomputeCollectionTankSums() {
        const { run, runReceipts } = this.props;
        const { pickup } = this.state;
        let changed = false;
        const pickupTanks = pickup.pickupTanks.map(tank => {
            const sum = sumCollectionReceiptLitres(runReceipts, run.id, pickup.id, tank.tankID);
            if (sum === null || sum === tank.driverEstimatedLitresPickedUp) {
                return tank;
            }
            changed = true;
            return { ...tank, driverEstimatedLitresPickedUp: sum, isManualEntry: false, isScalesConnected: true };
        });
        if (changed) {
            this.setState({ pickup: { ...pickup, pickupTanks } });
        }
    }
    
    componentDidMount() {
        let {pickup, tankId, scrollToThis} = this.props;        
        if(tankId > 0 && pickup.pickupTanks.findIndex(x => x.tankID === tankId) >= 0){
            this.setState({isEditMode: true, isOpen: true}, this.raiseOnEditChange);   
        } else if(tankId > 0 && scrollToThis){            
            this.onCancelEdit();
        }       
        if(scrollToThis){
            scrollToComponent(this.scrollRef.current, {
                offset: -70,
                align: 'top',
                duration: 1500
            });
        }
        this.props.dispatch(getGlobalSettings(GlobalSettings.RequireUrgentJobPhoto)).then(x => {
            if(!requestHasError({x})){
                this.setState({urgentPhotoUploadRequired:  x.data.value === "true"});
            }
        });
    }
    // File Upload functions
    handleFilesUpdate = ({payLoad, action="upload"}) => {
        store.dispatch(updatePickupPhotos({
            payLoad
        })).then(x => {
            if(!requestHasError({x})){
                toastr.success(action==="upload" ? "Images uploaded" : "Image deleted");
                store.dispatch(loadRun(this.props.run && this.props.run.id, null, null, false, true, false));
            }   
        });
    }
    // handle File update - upload and deletion

    // Handle file deletion
    handleFileDelete = ({image, index}) => {
        let tempFileCollection = [...mustBeArray(this.state.pickup && this.state.pickup.attachments)];
        tempFileCollection.splice(index, 1);
        this.setState({pickup: {...this.state.pickup, attachments: tempFileCollection}});
        const payLoad={
            attachments: tempFileCollection,
            id: this.state.pickup && this.state.pickup.id
        };
        toastr.info("Deleting image");
        this.handleFilesUpdate({payLoad, action:"delete"});
    };

    handleFileUploads = (e) => {
        if (isUploadedFileValid(e)) {
          let fileList = [];
          mustBeArray(e && e.base64).forEach((file,index) => {
              fileList = [...fileList, {
                fileContents: file,
                fileName: e.fileList[index] && e.fileList[index].name,
                id: -1
              }];
          });
        const payLoad={
            attachments: [...mustBeArray(this.state.pickup && this.state.pickup.attachments),...fileList],
            id: this.state.pickup && this.state.pickup.id
        };
        toastr.info("Uploading images");
        this.handleFilesUpdate({payLoad, action:"upload"});
        }
      };

    raiseOnEditChange(){
        let {onEditChange} = this.props;
        let {pickup, isEditMode} = this.state;
        
        onEditChange(pickup, isEditMode);
    }
    
    toggleIsOpen(e){
        e.preventDefault();
        this.setState({isOpen: !this.state.isOpen});
    }    

    onBeginEdit(e){
        e.preventDefault();
        if(isPickupUrgentForRunType(this.state.pickup, this.props.run && this.props.run.truckCollectionTypeCode) && _.isEmpty(mustBeArray(this.state.pickup.attachments))
            && IsInRole( this.props.account, ROLE_Driver) && this.state.urgentPhotoUploadRequired){
            return toastr.warning(URGENT_RUN_TAKE_PHOTOS_MESSAGE);
        }

        // Notify truck-proxy of the active pickup context
        const { run, dispatch } = this.props;
        const { pickup } = this.state;
        const isCollectionRun = run.isCollectionRun !== false; // Default to true if not specified
        dispatch(setPickupContext(run.id, pickup.id, isCollectionRun, null, run, pickup));

        this.setState({isEditMode: true});
    }

    onCancelEdit(e) {
        if(e) {
            e.preventDefault();
        }

        let {run, dispatch} = this.props;
        let {pickup} = this.state;

        // Clear the pickup context from truck-proxy
        dispatch(clearPickupContext());

        this.setState({
            isEditMode: false,
            isCancelMode: false,
            pickup: {...this.props.pickup},
            weight: {...defaultWeight},
        }, () => {
            store.dispatch(push(`${BASE_URL}/runs/driver/${run.id}/locations/${pickup.locationID}`));
        });
    }

    onSkipComplete(run){
        let current = this.props.run;
        store.dispatch(saveRunReorder(run, current));
    }
    
    onCancelPickup(e){
        this.onCompleteCancel(e,true);
    }       
    
    onCompletePickup(e) {
        this.onCompleteCancel(e, false);
    }
    
    onCompleteCancel(e, isCancel) {
        e.preventDefault();
        let {pickup} = this.state;
        let {run, dispatch} = this.props;

        let savePickup = {
            ...pickup,
            numberOfTinsCollected: pickup.isTinLocation && isNullEmptyOrWhitespace(pickup.numberOfTinsCollected) ? 0 : pickup.numberOfTinsCollected,
            pickupTanks: [...pickup.pickupTanks.map(x => {
                if (isNullEmptyOrWhitespace(x.driverEstimatedLitresPickedUp)) {
                    return {...x, driverEstimatedLitresPickedUp: 0};
                }
                return x;
            })]
        };

        store.dispatch(runLocationCompletePickup(savePickup, isCancel));

        // Clear the pickup context from truck-proxy
        dispatch(clearPickupContext());

        this.setState({
            isEditMode: false,
            isCancelMode: false,
            weight: {...defaultWeight},
        }, () => {
            store.dispatch(push(`${BASE_URL}/runs/driver/${run.id}/locations/${pickup.locationID}`));
        });
    }

    handleFinaliseAssignTank(pickup, tank) {
        let {run} = this.props;

        store.dispatch(runLocationCompleteAssignTank(pickup, tank));

        this.setState({
            isEditMode: false,            
            isCancelMode: false,
            selectedTank: null,
            weight: {...defaultWeight},
        }, () => {
            store.dispatch(push(`${BASE_URL}/runs/driver/${run.id}/locations/${pickup.locationID}`));
        });
    }
    
    handleAssignTank(e, tankRequest, pickup){
        e.preventDefault();        
        this.setState({selectedTank: tankRequest});
    }
    
    openReceiptModal(tank) {
        // Always pull the latest receipts as the picker opens, so the driver sees receipts that
        // arrived while they were mid-edit (realtime pushes can be missed during an edit session).
        if (this.props.run && this.props.run.id) {
            this.props.dispatch(loadRunReceipts(this.props.run.id));
        }
        this.setState({ receiptModalOpen: true, receiptModalTank: tank });
    }

    closeReceiptModal() {
        this.setState({ receiptModalOpen: false, receiptModalTank: null });
    }

    // Fills the selected tank's litres from the receipt and backfills the receipt's context in the
    // cloud DB. Mirrors the existing SignalR receipt-autofill (componentDidUpdate) — the driver then
    // completes the pickup as usual.
    handleSelectReceipt(receipt) {
        const {run} = this.props;
        const tank = this.state.receiptModalTank;
        this.setState({ receiptModalOpen: false, receiptModalTank: null }, () => {
            if (!tank) {
                return;
            }
            let {pickup} = this.state;
            let pickupTanks = [...pickup.pickupTanks.map(x => {
                if (x.tankID === tank.tankID) {
                    return {...x, driverEstimatedLitresPickedUp: receipt.deliveryTotal, isManualEntry: false, isScalesConnected: false};
                }
                return x;
            })];
            this.setState({ pickup: {...pickup, pickupTanks} });
            this.props.dispatch(assignReceipt(run.id, receipt.id, pickup.id, tank.tankID));
        });
    }

    openCollectionReceiptModal(tank) {
        // Always pull the latest receipts as the picker opens, so the driver sees receipts that
        // arrived while they were mid-edit (realtime pushes can be missed during an edit session).
        if (this.props.run && this.props.run.id) {
            this.props.dispatch(loadRunReceipts(this.props.run.id));
        }
        this.setState({ collectionReceiptModalOpen: true, collectionReceiptModalTank: tank });
    }

    closeCollectionReceiptModal() {
        this.setState({ collectionReceiptModalOpen: false, collectionReceiptModalTank: null });
    }

    // Assigns every selected receipt to the tank in the cloud DB; recomputeCollectionTankSums
    // (driven by the resulting runReceipts refresh) then sums them into the tank's litres — see
    // sumCollectionReceiptLitres above. Unlike handleSelectReceipt (delivery, overwrite), this adds.
    handleSelectCollectionReceipts(receipts) {
        const { run } = this.props;
        const tank = this.state.collectionReceiptModalTank;
        this.setState({ collectionReceiptModalOpen: false, collectionReceiptModalTank: null }, () => {
            if (!tank || !Array.isArray(receipts) || receipts.length === 0) {
                return;
            }
            const { pickup } = this.state;
            this.props.dispatch(assignReceipts(run.id, receipts.map(r => r.id), pickup.id, tank.tankID));
        });
    }

    handleTankInput(e, tankId) {
        let {pickup} = this.state;
        let {weightScales} = this.props;

        const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
        const driverEstimatedLitresPickedUp = e.target.value.match(regex)[0];
        let pickupTanks = [...pickup.pickupTanks.map(x => {
            if (x.id === tankId) {
                return {...x, driverEstimatedLitresPickedUp, isManualEntry: true, isScalesConnected: weightScales.connected};
            }
            return x;
        })];
        this.setState({
            pickup: {...pickup, pickupTanks},            
        });
    }

    handleTankPickup(e, tankId) {
        let {pickup} = this.state;        
        let isPickedUp = e.target.checked;

        let pickupTanks = [...pickup.pickupTanks.map(x => {
            if (x.id === tankId) {
                return {...x, isPickedUp};
            }
            return x;
        })];
        
        this.setState({pickup: {...pickup, pickupTanks}});
    }
    
    handleTinInput(e) {
        let {pickup} = this.state;

        let numberOfTinsCollected = isNullEmptyOrWhitespace(e.target.value) ? '' : parseInt(e.target.value);

        this.setState({pickup: {...pickup, numberOfTinsCollected}});
    }
    
    handleCancelPickup(e){
        e.preventDefault();
        this.setState({isCancelMode: true});
    }

    onLocationCheckInOut(e){
        e.preventDefault();

        let {run, pickup} = this.props;

        store.dispatch(runLocationCheckIn(run.id, pickup.id, 'Complete'));

        // Tie the truck's receipt context to this run for the whole run, not just per-pickup. On
        // check-in we set run-level context (runId, no pickup/tank) so receipts printed anywhere on
        // the run arrive tagged with the runId — they surface as "available" in the picker even when
        // the driver skips Start Pumping. On check-out we clear it so the truck stops tagging.
        if (pickup.isCheckIn) {
            const isCollectionRun = run.isCollectionRun !== false;
            store.dispatch(setPickupContext(run.id, null, isCollectionRun, null, run, null));
        } else if (pickup.isCheckOut) {
            store.dispatch(clearPickupContext());
        }
    }
    
    handleBeginDelivery(tankId) {
        const { run, dispatch } = this.props;
        const { pickup, weight } = this.state;
        const isCollectionRun = run.isCollectionRun !== false;

        // Set tank context for delivery
        dispatch(setPickupContext(run.id, pickup.id, isCollectionRun, tankId, run, pickup));

        this.setState({
            weight: {...weight,
                isWeighing: true,  // Reuse to track "active delivery"
                tankId: tankId,
            }
        });
    }

    handleEndDelivery(tankId) {
        const { run, dispatch } = this.props;
        const { pickup, weight } = this.state;
        const isCollectionRun = run.isCollectionRun !== false;

        // Clear tank context
        dispatch(setPickupContext(run.id, pickup.id, isCollectionRun, null, run, pickup));

        this.setState({
            weight: {...weight,
                isWeighing: false,
                tankId: null,
            }
        });
    }

    handleUpdateQrAsset=({pickup}) => {
        const {run} = this.props;
        store.dispatch(push(`${BASE_URL}/runs/search/${run && run.id}/locations/${pickup && pickup.locationID}/qrAsset/update`))
    }
    
    render() {
        let {run, tankId, enableEdit, dropOffTanks, pickupTanks, account} = this.props;
        let {pickup, isEditMode, isCancelMode, selectedTank, weight} = this.state;
        // What is this?
        let handleFocus = function (e) {
            let target = e.target;
            setTimeout(function () {
                target.select();
            }, 0);
        };
        const userHasDriverRole = IsInRole( account, ROLE_Driver);
        const attachments = mustBeArray(pickup && pickup.attachments);
        // The console renders a number pad (Main mounts it) but deliberately no alphabetic one.
        // Free text stays read-only here and offers the canned phrases instead - a driver in gloves
        // at the pump-out is not going to type a sentence, and the note can be added from the phone
        // they already used to sign the console in.
        const kiosk = isKioskMode();
        return (<div className="row" ref={this.scrollRef}>
                <div className="col-12">
                    <div className="card" style={getRunTypeCardStyle(run.truckCollectionTypeCode)}>
                        <div className="card-block">
                            <div className="row">
                                <div className={userHasDriverRole ? "col-9" : "col-12"} onClick={this.toggleIsOpen}>
                                    <PickupStatus pickup={pickup} run={run} userHasDriverRole={userHasDriverRole} urgentPhotoUploadRequired={this.state.urgentPhotoUploadRequired}/>
                                    <span className={getRunFlagBadgeClass(run.truckCollectionTypeCode) + ' ml-1'} style={{fontSize: '75%'}}>
                                        <i className={getRunFlagIcon(run.truckCollectionTypeCode)}/> {getRunFlag(run.truckCollectionTypeCode)}
                                    </span>
                                    {!pickup.isBase && (
                                        <h6 className="text-muted">{getCollectionAction(run.truckCollectionTypeCode)} <span
                                            className="badge badge-info mr-1">{pickup.volume ? pickup.volume : 'O L'}</span>
                                            <span className="badge badge-info">{pickup.numTanks}</span><br/></h6>
                                    )}
                                    {!pickup.isBase && (
                                        <h6 className="text-muted">Expected <span
                                            className="badge badge-info">{pickup.expectedVolumeRaw}</span></h6>
                                    )}
                                    <h5 style={{marginTop: 10}}>{pickup.clientCompanyName}</h5>
                                    {pickup.locationNotes && (
                                        <h6><i className="fa fa-book"/>&nbsp;&nbsp;{pickup.locationNotes}</h6>)}
                                    {pickup.pickupNote && pickup.pickupNote != '' && (
                                        <h6><i className="fa fa-book"/>&nbsp;&nbsp;{pickup.pickupNote}</h6>)}
                                     
                                </div>
                                {
                                    userHasDriverRole  && !pickup.isBase &&
                                    <div className= "col-3">
                                        {
                                            isPickupUrgentForRunType(pickup, run && run.truckCollectionTypeCode) && this.state.urgentPhotoUploadRequired &&
                                            <ReactFileReader base64 multipleFiles={true}
                                                handleFiles={this.handleFileUploads}>
                                                <i className="fa fa-camera float-right ml-1" style={{fontSize: "40px", marginTop: "4px"}} aria-hidden="true" ></i>
                                            </ReactFileReader>
                                        }
                                        
                                        {
                                            !pickup.isTinLocation && 
                                            <QrAssetUpdateIcon handleUpdateQrAsset={() => this.handleUpdateQrAsset({pickup})}/>
                                        }
                                        
                                        <div className='clearfix' />
                                    </div>
                                }
                               
                            </div>
                            <div className="row">
                                <div className="col-9">
                                    <h6><a href={`http://maps.google.com/maps?&z=21&q=${pickup.locationLatitude}+${pickup.locationLongitude}`}
                                           target={'_blank'}>{`${pickup.locationLatitude}, ${pickup.locationLongitude}`}</a></h6>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-9">
                                    <h6><i className="icon-location-pin"/>&nbsp;{pickup.locationFullAddress}</h6>
                                </div>
                                {this.state.isOpen &&    <div className="col-3 text-right">
                                    <button onClick={(e) => {
                                        if (IsCordovaApp()) {
                                            window.open(`geo://0,0?q=${pickup.locationLatitude},${pickup.locationLongitude}(${encodeURI(pickup.clientCompanyName)})`, '_system', 'location=yes');
                                        } else {
                                            window.open(`https://www.google.com/maps/dir/?api=1&destination=${pickup.locationLatitude},${pickup.locationLongitude}&travelmode=driving`, '_blank');
                                        }
                                    }}
                                            className="btn btn-info">
                                        <i className="fa fa-truck fa-2x" />                                        
                                    </button>
                                </div> }
                            </div>                            
                            <Collapse isOpen={this.state.isOpen}>
                                {pickup.locationContacts.map(x => {
                                    return (
                                        <div className="row" key={x.id}>
                                            <div className="col-12"><strong><i
                                                className="fa fa-male"/>&nbsp;&nbsp;</strong><span
                                                style={{marginRight: '10px'}}>{x.fullName}</span>
                                                {x.communications.filter(y => y.communicationType.toLowerCase().includes('phone')).map(c => {
                                                    return (
                                                        <a key={c.id} href={`tel:${c.detail}`}
                                                           style={{marginRight: '10px'}}><strong><i
                                                            className="fa fa-phone"/>&nbsp;</strong>{c.detail}</a>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    );
                                })}
                                {pickup.locationCommunications.filter(y => y.communicationType.toLowerCase().includes('phone')).map(x => {
                                    return (
                                        <div className="row" key={x.id}>
                                            <div className="col-12"><a href={`tel:${x.detail}`}><strong><i
                                                className="fa fa-phone"/>&nbsp;&nbsp;</strong>{x.detail}</a></div>
                                        </div>
                                    );
                                })}
                                <CheckInView run={run} pickup={pickup} onLocationCheckin={this.onLocationCheckInOut} enableEdit={enableEdit} />
                                <CheckOutView run={run} pickup={pickup} onLocationCheckin={this.onLocationCheckInOut} enableEdit={enableEdit} />                                 
                                <TankInput run={run} pickup={pickup} tankId={tankId} isEditMode={isEditMode}
                                           onInputTank={this.handleTankInput}
                                           onPickupTank={this.handleTankPickup}
                                           isWeighing={weight.isWeighing}
                                           weighingTankId={weight.tankId}
                                           onBeginDelivery={this.handleBeginDelivery}
                                           onEndDelivery={this.handleEndDelivery}
                                           handleFocus={handleFocus}
                                           isCollectionRun={run.isCollectionRun !== false}
                                           latestReceipt={this.props.truckData?.receipt}
                                           onOpenReceiptModal={this.openReceiptModal}
                                           onOpenCollectionReceiptModal={this.openCollectionReceiptModal}
                                           onCompletePickup={() => {
                                }}/>
                                <SelectReceiptModal
                                    isOpen={this.state.receiptModalOpen}
                                    toggle={this.closeReceiptModal}
                                    receipts={(this.props.runReceipts && this.props.runReceipts.runId === run.id && Array.isArray(this.props.runReceipts.items))
                                        ? this.props.runReceipts.items.filter(r => !r.tankId && r.type !== 'Collection') : []}
                                    assignedReceipts={(this.props.runReceipts && this.props.runReceipts.runId === run.id && Array.isArray(this.props.runReceipts.items))
                                        ? this.props.runReceipts.items.filter(r => r.tankId && r.pickupId === this.state.pickup.id && r.type !== 'Collection') : []}
                                    loading={this.props.runReceipts && this.props.runReceipts.loading}
                                    tankLabel={this.state.receiptModalTank ? `#${this.state.receiptModalTank.tankID}` : null}
                                    onSelect={this.handleSelectReceipt}
                                    onUnassign={(receipt) => this.props.dispatch(unassignReceipt(run.id, receipt.id))}
                                    onManualEntry={this.closeReceiptModal}
                                />
                                <SelectCollectionReceiptsModal
                                    isOpen={this.state.collectionReceiptModalOpen}
                                    toggle={this.closeCollectionReceiptModal}
                                    receipts={(this.props.runReceipts && this.props.runReceipts.runId === run.id && Array.isArray(this.props.runReceipts.items))
                                        ? this.props.runReceipts.items.filter(r => !r.tankId && r.type === 'Collection') : []}
                                    assignedReceipts={(this.props.runReceipts && this.props.runReceipts.runId === run.id && Array.isArray(this.props.runReceipts.items))
                                        ? this.props.runReceipts.items.filter(r => r.tankId && r.pickupId === this.state.pickup.id && r.type === 'Collection') : []}
                                    loading={this.props.runReceipts && this.props.runReceipts.loading}
                                    tankLabel={this.state.collectionReceiptModalTank ? `#${this.state.collectionReceiptModalTank.tankID}` : null}
                                    onConfirm={this.handleSelectCollectionReceipts}
                                    onUnassign={(receipt) => this.props.dispatch(unassignReceipt(run.id, receipt.id))}
                                    onManualEntry={this.closeCollectionReceiptModal}
                                />
                                {/* Compact last-receipt summary for this pickup (delivery runs). Kept small
                                    for mobile: one line with amount, tank and the time it was received. */}
                                {this.props.truckData?.receipt
                                    && this.props.truckData.receipt.pickupId === pickup.id && (
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="alert alert-success py-1 px-2 mb-2" role="alert">
                                                <small>
                                                    <i className="fa fa-file-text-o mr-1"/>
                                                    <strong>Last receipt</strong> {this.props.truckData.receipt.deliveryTotal}L
                                                    {this.props.truckData.receipt.tankId ? ` · Tank #${this.props.truckData.receipt.tankId}` : ''}
                                                    {this.props.truckData.receipt.receivedAt ? ` · ${moment(this.props.truckData.receipt.receivedAt).format('DD/MM/YYYY LT')}` : ''}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <TinInput run={run} pickup={pickup} onInputTin={this.handleTinInput} handleFocus={handleFocus} isEditMode={isEditMode}/>
                                <TankRequestInput run={run} pickup={pickup} tankId={tankId} isEditMode={isEditMode}
                                           onAssignTank={this.handleAssignTank} />
                                <TankAssignView 
                                    onTankAssigned={(tank)=>this.handleFinaliseAssignTank(pickup, tank)} 
                                    onCancel={()=> this.setState({selectedTank: null})} 
                                    baseLocationIds={[]} 
                                    tankRequestId={IsNullOrUndefined(selectedTank) ? null : selectedTank.id}
                                    basicMatch={true}
                                />

                                {pickup.notes.length > 0 &&
                                <Aux>
                                    <div className={"row"}><div className={"col-12"}><h5>Pickup Notes</h5></div></div>
                                    { pickup.notes.map(note => (<div className={"row"} key={note.id}>                                        
                                        <div className={"col-12"}>
                                            <a href={`#note_detail_${note.id}`}
                                               aria-expanded="false" 
                                               aria-controls={`note_detail_${note.id}`}   
                                               data-toggle="collapse">{note.noteText}</a></div>
                                        
                                        <div className="collapse col-12" id={`note_detail_${note.id}`}>                                                
                                            <div className={"row"}>
                                                <div className={"col-12"}>{note.updatedBy}</div>                                                
                                            </div>
                                            <div className={"row"}>
                                                <div className={"col-12"}>{moment(note.createdDate).format('DD/MM/YYYY LT')}</div>
                                            </div>                                            
                                        </div>
                                    </div>)) }
                                    <div className="mb-0">&nbsp;</div>
                                </Aux>
                                }


                                {isEditMode && !isCancelMode &&
                                <div className="row form-group form-inline">
                                    <div className="col-12 input-group">
                                        <div className="input-group-addon">
                                            <button type="button"
                                                    className="btn dropdown-toggle"
                                                    data-toggle="dropdown">Notes<span className="caret" />
                                            </button>
                                            <div className="dropdown-menu">
                                                {CommonNotes.map(x => {
                                                    return (<a className="dropdown-item"
                                                               onClick={(e) => {
                                                                   e.preventDefault();
                                                                   this.setState({pickup: {...pickup, driverEnteredPickupNote: x}});
                                                               }}
                                                               href="#" key={x}>{x}</a>);
                                                })}
                                            </div>
                                        </div>
                                        <textarea value={isNullEmptyOrWhitespace(pickup.driverEnteredPickupNote) ? '' : pickup.driverEnteredPickupNote}
                                                  onChange={(e)=>{
                                                      this.setState({pickup: {...pickup, driverEnteredPickupNote: e.target.value}});
                                                  }}
                                                  readOnly={kiosk}
                                                  className="form-control"
                                                  placeholder={kiosk
                                                      ? 'Choose a note above, or add one from your phone'
                                                      : 'Enter a pickup note or select existing'} />
                                    </div>
                                </div> }

                                {isEditMode && isCancelMode &&
                                <Aux>
                                    <div className={"row"}>
                                        <div className={"col-12"}><h5>Please enter a reason for cancellling</h5></div>
                                    </div>
                                    <div className="row form-group form-inline">
                                        <div className="col-12 input-group">
                                            <div className="input-group-addon">
                                                <button type="button"
                                                        className="btn dropdown-toggle"
                                                        data-toggle="dropdown">Reasons<span className="caret" />
                                                </button>
                                                <div className="dropdown-menu">
                                                    {CancelNotes.map(x => {
                                                        return (<a className="dropdown-item"
                                                                   onClick={(e) => {
                                                                       e.preventDefault();
                                                                       this.setState({pickup: {...pickup, cancelReason: x}});
                                                                   }}
                                                                   href="#" key={x}>{x}</a>);
                                                    })}
                                                </div>
                                            </div>
                                            <textarea value={isNullEmptyOrWhitespace(pickup.cancelReason) ? '' : pickup.cancelReason}
                                                      onChange={(e)=>{
                                                          this.setState({pickup: {...pickup, cancelReason: e.target.value}});
                                                      }}
                                                      readOnly={kiosk}
                                                      className="form-control"
                                                      placeholder={kiosk
                                                          ? 'Choose a reason above, or cancel from your phone'
                                                          : 'Enter a reason for cancelling or select existing'} />
                                        </div>
                                    </div>
                                </Aux>}

                                {!pickup.isBase && pickup.pickupStatusCode === 'PEN' && !isEditMode &&
                                <div className="row">
                                    <div className="col-md-12 col-xs-12">
                                        <PickupSkipView pickup={pickup} run={run} onFinished={this.onSkipComplete}/>
                                    </div>
                                </div>}

                                {/* Display photos uploaded by driver */}
                                <div className="flex flex-wrap mb-1">
                                    {
                                        attachments.map((image,i) => {
                                            return(
                                                <div className="mb-1 pl-1 pr-1 mt-2" key={i}>
                                                    <div><img src={image.blobUri || image.fileContents} key={i} width="285px" height="100%" className="mb-q"/></div>
                                                    <div className="mr-q float-left" style={{width: "270px",textOverflow: "ellipsis", overflow: "clip"}}>
                                                        {image.fileName}
                                                    </div>
                                                    {
                                                       userHasDriverRole &&
                                                        <i className="fa fa-times hand float-right pt-q text-danger" aria-hidden="true" onClick={e => this.handleFileDelete({image, index: i})} />
                                                    }
                                                    
                                                    <div className="clearfix"/>
                                                </div>
                                            );
                                        })
                                    }
                                </div>

                                {(!run.isBaseCheckedIn || run.isComplete || pickup.isCheckIn || pickup.isCheckOut || this.state.isCancelView || weight.isWeighing) ? null :
                                    <div className="row mb-1">
                                        <div className="col-4">
                                            {isEditMode && !isCancelMode &&
                                            <button className={'btn btn-success mr-1'}
                                                    onClick={this.onCompletePickup}><i className={'fa fa-check fa-3x'} />
                                            </button>}
                                            {isEditMode && isCancelMode &&
                                            <button className={'btn btn-danger mr-1'}
                                                    disabled={isNullEmptyOrWhitespace(pickup.cancelReason)}
                                                    onClick={this.onCancelPickup}><i className={'fa fa-check fa-3x'} />
                                            </button>}
                                            { !isEditMode && <PickupImageViewer pickup={pickup} isDelivery={run.truckCollectionTypeCode === 'BD' || run.truckCollectionTypeCode === 'BIBD'} /> }
                                        </div>
                                        <div className="col-4 text-center">
                                            {isEditMode && pickup.pickupStatusCode === 'PEN' && !isPickupUrgentForRunType(pickup, run && run.truckCollectionTypeCode) && !isCancelMode &&
                                            <button className={'btn btn-danger'} onClick={this.handleCancelPickup}><i className={'fa fa-ban fa-3x'} /></button>}
                                        </div>
                                        <div className="col-4 text-right">
                                            {isEditMode && <button className={'btn btn-default'} onClick={this.onCancelEdit}><i className={'fa fa-times fa-3x'} /></button> }
                                            { !isEditMode && enableEdit && <button className={'btn btn-primary'} onClick={this.onBeginEdit}><i className={'fa fa-edit fa-3x'} /></button> }
                                        </div>
                                    </div>
                                }

                                {!pickup.isBase && (
                                    <div className="row">
                                        <div className="col-md-12 col-xs-12 font-weight-bold">
                                            Total <span
                                            className="badge badge-info">{`${parseFloat(run.totalEstimatedLitresPickedUp).toFixed(2)} L `}</span>&nbsp;from&nbsp;
                                            <span
                                                className="badge badge-info">{`${run.pickupsComplete}/${run.pickupsToComplete}`}</span> locations
                                            Capacity <span
                                            className="badge badge-info">{`${parseFloat(run.truckCapacity).toFixed(2)} L`}</span>
                                        </div>
                                    </div>
                                )}
                            </Collapse>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

DriverPickupView.propTypes = {
    tankId: PropTypes.number,
    pickup: PropTypes.object.isRequired,
    run: PropTypes.object.isRequired,
    enableEdit: PropTypes.bool.isRequired,
    onEditChange: PropTypes.func.isRequired,
    scrollToThis: PropTypes.bool.isRequired,
    weightScales: PropTypes.object.isRequired,
    truckData: PropTypes.object,
};

DriverPickupView.defaultProps = {
    truckData: null,
};

function mapStateToProps(state) {
    return {
        truckData: state.truckData,
        runReceipts: state.runReceipts,
    };
}

function mapDispatchToProps(dispatch) {
    return {
      dispatch,
      getGlobalSettings,
    };
  }

export default connect(mapStateToProps, mapDispatchToProps)(DriverPickupView);